import { createSelector } from 'reselect'

import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import editModes from 'helpers/enums/creationTool/editModes'

const getEditDuplicationMode = state => state.interactiveVideoCreation.editMode

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.UNPUBLISH_VIDEO_LESSONS_EDIT_OEQ_AND_MCQ,
])

export default createSelector(
	[ getEditDuplicationMode, featureFlagsSelector ],
	( editMode, featureFlags ) => {
		const canUseNotDuplicateOnEditMode = featureFlags[featureFlagsTypes.UNPUBLISH_VIDEO_LESSONS_EDIT_OEQ_AND_MCQ]
		if (!canUseNotDuplicateOnEditMode) {
			return editModes.DUPLICATE_ON_EDIT
		}
		return editMode
	}
)
